import "#legacy/utilities/ordered_ajax.js";
import "#legacy/utilities/params.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Helpers ??= {};

AppointmentBooking.SlotPickerModal.Helpers.Fetcher = class Fetcher {
  constructor() {
    this.fetch = this.fetch.bind(this);
    this.prepareParams = this.prepareParams.bind(this);
  }

  fetch(params) {
    return Sparkle.Utilities.OrderedAJAX.getJSON(
      `AppointmentBooking.SlotPickerModal.${this.api}`,
      this.endpoint,
      jQuery.extend({ api: this.api }, this.prepareParams(params)),
    ).then(this.processor);
  }

  prepareParams(params) {
    return Sparkle.Utilities.sanitizeParams(params);
  }
};
AppointmentBooking.SlotPickerModal.Helpers.Fetcher.prototype.endpoint = null;
AppointmentBooking.SlotPickerModal.Helpers.Fetcher.prototype.api = null;
AppointmentBooking.SlotPickerModal.Helpers.Fetcher.prototype.processor = null;
